import _ from 'underscore';

import BaseView from '../../../base-view';
import template from './template.html';

export default BaseView.extend({

	tagName: 'li',
	className: 'suggest__item',

	events: {
		'click': 'onItemSelect'
	},

	template: _.template(template),

	initialize: function(options) {
		// set the type of item
		this.type = options && options.type || this.type;

		// listeners
		this.listenTo(this.model, 'remove', this.remove);
		this.listenTo(this.model, 'change:IsSelected', this.onSelectedChange);
		this.listenTo(this.model, 'change:IsHighlighted', this.onHighlightedChange);
	},

	/**
	 * model IsSelected change listener
	 **/
	onSelectedChange: function(model, selected) {
		this.el.classList.toggle('is-selected', selected);
	},

	/**
	 * model IsHighlighted change listener
	 **/
	onHighlightedChange: function(model, highlighted) {
		this.el.classList.toggle('is-highlighted', highlighted);
	},

	/**
	 * item select handler
	 **/
	onItemSelect: function(e) {
		e.preventDefault();

		this.model.set('IsSelected', true);
	},

	/**
	 * fill el with template HTML
	 **/
	render: function() {
		this.el.innerHTML = this.template(this.model.toJSON());
		return this;
	}
});
